/**
 *
 * @module mediaCapabilitiesProvider
 *
 */

import Check from 'check-types';
import Services from './../services/entry';
import Logging from './../logging/entry';

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class MediaCapabilitiesProvider
 * @since 3.8.0
 * @desc Defines the contract for a class that can provide the current media capabilities of the device.
 *
 */
export default class MediaCapabilitiesProvider {

    /**
     *
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(logger = Logging) {

        const errorMessage = {
            ctor: 'MediaCapabilitiesProvider(logger)',
            get logger() {
                return `${this.ctor} needs SDK.Logger instance`;
            }
        };

        instanceStrict(logger, Logging.Logger, errorMessage.logger, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {SDK.Logging.Logger}
         *
         */
        this.logger = logger;

        this.logger.log(MediaCapabilitiesProvider.name, 'Created provider');

    }

    /**
     *
     * @access public
     * @method getSupportedHdrTypes
     * @desc An interface method. Retrieves the supported HDR types of the device. An
     * empty array signifies HDR is not compatible.
     * @returns {Array<SDK.Media.HdrType>}
     *
     */
    getSupportedHdrTypes() {

        return [];

    }

}



// WEBPACK FOOTER //
// ./src/media/mediaCapabilitiesProvider.js